import Dexie from 'dexie';

const db = new Dexie('prefixDb');

db.version(1).stores({
    problems: `++id, clusterId, userId, number, randomPrefFrom, randomPrefTo, randomUnit, expSolution, standardExpSolution, standardSolution, solvedExp, solvedStand`,
    clusters: `++id, userId, dateCreated, done, expSolved, standardSolved, solved, numOfProblems`,
    users: `++id, dateCreated, &pin, active, *stats`
});

export default db;
